// MWA-394 — how a client reaches one of their interviews. The portal has no
// Interviews page (removed on purpose), so an interview opens as a dialog over
// the Front Door page, and a link to one is a query string on that page.

export const PORTAL_INTERVIEW_PARAM = 'interview'
export const PORTAL_INTERVIEW_SECTION_PARAM = 'section'

/** Sections of the interview dialog a link may scroll to. */
export type InterviewDialogSection = 'guide'

const FRONT_DOOR_PATH = '/portal/opportunities'

export function portalInterviewPath(
  interviewId: string,
  section?: InterviewDialogSection
): string {
  const params = new URLSearchParams({ [PORTAL_INTERVIEW_PARAM]: interviewId })
  if (section) params.set(PORTAL_INTERVIEW_SECTION_PARAM, section)
  return `${FRONT_DOOR_PATH}?${params.toString()}`
}

export interface PortalInterviewRequest {
  interviewId: string
  section?: InterviewDialogSection
}

/** The interview a URL asks for, or null when it asks for none. */
export function readPortalInterviewRequest(
  params: URLSearchParams
): PortalInterviewRequest | null {
  const interviewId = params.get(PORTAL_INTERVIEW_PARAM)?.trim()
  if (!interviewId) return null
  const section = params.get(PORTAL_INTERVIEW_SECTION_PARAM) === 'guide' ? 'guide' : undefined
  return { interviewId, section }
}

// NOTE: copy is a sensible default — final wording is pending Dee's team.
export function interviewGuidePublishedMessage(data: {
  role?: string
  company?: string
}): string {
  const role = data.role?.trim()
  const company = data.company?.trim()
  if (role && company) {
    return `Your interview prep guide for ${role} at ${company} is ready.`
  }
  if (company) return `Your interview prep guide for ${company} is ready.`
  return 'Your interview prep guide is ready.'
}
